import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

@Component({
  selector: 'app-error-popup',
  templateUrl: './error-popup.component.html',
  styleUrls: ['./error-popup.component.scss']
})
export class ErrorPopupComponent {
  @Input() isFromPreview: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    private router: Router
  ) {}

  onBackToMainPage(): void {
    this.activeModal.close('back-to-main');
  }

  onGoBack(): void {
    this.activeModal.close('go-back');
  }

  onClose(): void {
    this.activeModal.close('close');
  }
}
